export { default as Button } from './Button'
export { default as Head } from './Head'
// 需保证Modal在Header之前引入，避免build时报错无法生成静态页面
export { default as Modal } from './Modal'
// export { default as Header } from './Header'
export { default as PhoneItem } from './PhoneItem'
export { default as SMSCode } from './SMSCode'
export { default as StickyDownload } from './StickyDownload'
export { default as Captcha } from './Captcha'
export { default as PhoneInput } from './PhoneInput'
export { default as Profile } from './Profile'
export { default as Share } from './Share'
export { default as Tips } from './Tips'
export { default as SocialMedia } from './SocialMedia'
export { default as CampaignRules } from './CampaignRules'
export { default as InviteCode } from './InviteCode'
export { default as Banners } from './Banners'
export { default as Markdown } from './Markdown'
export { Link } from 'react-router-dom'
